import React from 'react';
import { Page, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';
import { formatToCLP } from '../services/monedaService';

// Registrar fuentes (asegúrate de que estas fuentes estén disponibles en tu proyecto)


const styles = StyleSheet.create({
  page: {
    padding: 30,
 
    fontSize: 10,
    color: '#333333',
    backgroundColor: '#ffffff',
  },
  header: {
    marginBottom: 20,
  },
  companyName: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 4,
    color: '#2c3e50',
  },
  documentTitle: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 4,
    color: '#3498db',
  },
  quotationNumber: {
    fontSize: 12,
    fontWeight: 400,
  },
  section: {
    marginBottom: 15,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 700,
    marginBottom: 8,
    color: '#2c3e50',
    borderBottomWidth: 1,
    borderBottomColor: '#3498db',
    paddingBottom: 2,
    marginTop: 10,
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderColor: '#ecf0f1',
    borderWidth: 1,
    marginVertical: 8,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#ecf0f1',
  },
  tableCol: {
    flexGrow: 1,
    flexBasis: 0,
    padding: 6,
  },
  tableHeader: {
    backgroundColor: '#3498db',
  },
  tableHeaderText: {
    color: '#ffffff',
    fontWeight: 700,
    fontSize: 10,
  },
  tableText: {
    fontSize: 9,
  },
  total: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 15,
    borderTopWidth: 1,
    borderTopColor: '#3498db',
    paddingTop: 8,
  },
  totalLabel: {
    fontSize: 12,
    fontWeight: 700,
    marginRight: 10,
  },
  totalAmount: {
    fontSize: 12,
    fontWeight: 700,
    color: '#3498db',
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    textAlign: 'center',
    fontSize: 9,
    color: '#7f8c8d',
  },
  note: {
    marginTop: 20,
    fontSize: 9,
    fontStyle: 'italic',
    color: '#34495e',
  },
});

const InstallmentPDF = ({
  installments = [],
  totalAmount = 0,
  lineOfBusinessName = '',
  formData = {},
  services = [],
  fechaSolicitud = '',
  fechaContrato = '',
  paymentMethodName = '',
  numCuotas = 0,
}) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <Text style={styles.companyName}>GRUPO DEFENSA DEUDORES</Text>
        <Text style={styles.documentTitle}>COTIZACIÓN DE SERVICIOS</Text>
        <Text style={styles.quotationNumber}>N° Contrato {formData.numContrato || 'N/A'}</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Datos del Solicitante</Text>
        <View style={styles.table}>
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={[styles.tableCol, styles.tableHeaderText]}>Cliente</Text>
            <Text style={[styles.tableCol, styles.tableHeaderText]}>Identificador</Text>
            <Text style={[styles.tableCol, styles.tableHeaderText]}>Fecha de Solicitud</Text>
            <Text style={[styles.tableCol, styles.tableHeaderText]}>Fecha de Contrato</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCol, styles.tableText]}>{formData.firstName || 'N/A'}</Text>
            <Text style={[styles.tableCol, styles.tableText]}>{formData.identifier || 'N/A'}</Text>
            <Text style={[styles.tableCol, styles.tableText]}>{fechaSolicitud || 'N/A'}</Text>
            <Text style={[styles.tableCol, styles.tableText]}>{fechaContrato || 'N/A'}</Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Línea de Negocio</Text>
        <Text style={styles.tableText}>{lineOfBusinessName || 'N/A'}</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Servicios Contratados</Text>
        <View style={styles.table}>
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={[styles.tableCol, styles.tableHeaderText]}>Servicio</Text>    
            <Text style={[styles.tableCol, styles.tableHeaderText]}>Monto</Text>
          </View>
          {services.map((service, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={[styles.tableCol, styles.tableText]}>{service.serviceName}</Text>         
              <Text style={[styles.tableCol, styles.tableText]}>{formatToCLP(service.amount)}</Text>
            </View>
          ))}
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Plan de Cuotas</Text>
        <View style={styles.table}>
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={[styles.tableCol, styles.tableHeaderText]}>N° Cuota</Text>
            <Text style={[styles.tableCol, styles.tableHeaderText]}>Fecha de Vencimiento</Text>
            <Text style={[styles.tableCol, styles.tableHeaderText]}>Monto</Text>
          </View>
          {installments.map((installment, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={[styles.tableCol, styles.tableText]}>{installment.number}</Text>
              <Text style={[styles.tableCol, styles.tableText]}>
                {new Date(installment.date).toLocaleDateString('es-CL')}
              </Text>
              <Text style={[styles.tableCol, styles.tableText]}>{formatToCLP(installment.amount)}</Text>
            </View>
          ))}
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Detalles del Contrato</Text>
        <View style={styles.table}>
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={[styles.tableCol, styles.tableHeaderText]}>Fecha del Contrato</Text>
            <Text style={[styles.tableCol, styles.tableHeaderText]}>Método de Pago</Text>
            <Text style={[styles.tableCol, styles.tableHeaderText]}>Cantidad de Cuotas</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCol, styles.tableText]}>{fechaContrato || 'N/A'}</Text>
            <Text style={[styles.tableCol, styles.tableText]}>{paymentMethodName || 'N/A'}</Text>
            <Text style={[styles.tableCol, styles.tableText]}>{numCuotas || 'N/A'}</Text>
          </View>
        </View>
      </View>

      <View style={styles.total}>
        <Text style={styles.totalLabel}>Monto Total:</Text>
        <Text style={styles.totalAmount}>{formatToCLP(totalAmount)}</Text>
      </View>

      <Text style={styles.note}>
        Esta cotización es válida por 30 días a partir de la fecha de emisión. Los precios pueden estar sujetos a cambios sin previo aviso.
      </Text>

      <Text style={styles.footer}>
        Gracias por confiar en nuestros servicios. Para cualquier consulta, no dude en contactarnos.
      </Text>
    </Page>
  </Document>
);

export default InstallmentPDF;